module.exports = __webpack_public_path__ + "img/heart-outline.92609735.svg";